export const registerConstants = {
    REGISTER_REQUEST: "REGISTER_REQUEST",
    REGISTER_ERROR: "REGISTER_ERROR",
    REGISTER_SUCCESS: "REGISTER_SUCCESS",
  };
  
